import React from "../../__compat__/react/main.entry.mjs.mjs";
import { GenericNavigationItem } from "../GenericNavigation/index.mjs.mjs";
export const NavigationItem = React.forwardRef((props, ref) => (React.createElement(GenericNavigationItem, { ...props, ref: ref })));
NavigationItem.displayName = 'NavigationItem';
//# sourceMappingURL=NavigationItem.mjs.mjs.map